export const PARTY_OPTIONS_DEFAULT = {
  allowTrackDuplicates: true,
  partyGuestLimit: 10,
  partyPassword: '',
  trackMaxLength: 0,
}
